import { requestJsonWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { CatalogServiceProductData } from './types';

const config = getConfig();

export const fetchProducts = async (
  productCodes: Array<number>,
): Promise<CatalogServiceProductData[] | null> => {
  try {
    const body = await requestJsonWithTimeout({
      apiEndpoint: config.publicRuntimeConfig.CATALOG_API_ENDPOINT,
      apiPath: config.publicRuntimeConfig.CATALOG_API_PATH,
      method: 'POST',
      body: {
        productCodes,
      },
      timeout: 1000,
    });

    // @ts-ignore
    return body.products;
  } catch (error) {
    console.error(`error in fetchProducts: ${String(error)}`);
  }

  return null;
};
